import {
  createFileRoute,
  ErrorComponent,
  ErrorComponentProps,
  Outlet,
  redirect,
  useRouter
} from "@tanstack/react-router";
import { getUsersMeRetrieveQueryOptions } from "@/api/generated/backendAPI";
import {useEffect} from 'react'
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { isTokenExpired } from "@/lib/session";


export const Route = createFileRoute("/_layout/_auth")({
  beforeLoad: async ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: "/signin",
        search: {
          redirect: location.href,
        },
      });
    }
    // ID Token が期限切れ（または期限間近）なら refresh を試みる。
    if (isTokenExpired()) {
      const refreshed = await context.auth.refreshIdToken();
      if (!refreshed) {
        // refresh 失敗時は認証状態を完全にクリアしてからリダイレクトする。
        // そうしないと signin 側が `isAuthenticated && idToken` で保護ルートへ戻し、
        // refresh が失敗し続ける状況（ネットワーク断・auth-relay 障害など）で
        // signin ↔ 保護ルートの無限リダイレクトループになる。
        await context.auth.logout();
        throw redirect({
          to: "/signin",
          search: {
            redirect: location.href,
          },
        });
      }
    }
  },
  loader: ({ context: { queryClient } }) => {
    queryClient.ensureQueryData(getUsersMeRetrieveQueryOptions());
  },
  component: AuthLayout,
  errorComponent: ErrorAuthComponent,
});

function ErrorAuthComponent({ error }: ErrorComponentProps) {

  const queryErrorResetBoundary = useQueryErrorResetBoundary();
  const router = useRouter();
  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary, error]);
  return (
    <div>
      <button
        onClick={() => {
          router.invalidate();
        }}
      >
        再実行
      </button>
      <ErrorComponent error={error} />
    </div>
  );
}

function AuthLayout() {
  return (
    <>
      <div className="flex items-start max-w-screen-2xl mx-auto min-h-full">
        <section className="flex-auto m-4 p-4">
          <Outlet />
        </section>
      </div>
    </>
  );
}
